import { createStore } from 'vuex'
import pathify from "@/plugins/vuex-pathify";
import app from "./modules/app";
import user from './modules/user';
import userFamilyRoles from './modules/userFamilyRoles';


export default createStore({
  plugins: [pathify.plugin],
  modules: {
    app,
    user,
    userFamilyRoles
  },
  
});
